import React, { Component } from "react";
import { gaEvent } from "../../util/ga";

// components
import Field from "../Field/Field";
import Results from "../Results/Results";

export class ActiveStep extends Component {
  componentDidMount() {
    gaEvent({
      action: "Enter step",
      category: "Branntips form",
      label: this.props.step.name,
    });
  }

  render() {
    const { title, desc, fields } = this.props.step;
    return (
      <div className="active-step">
        <h1 className="step-title md:text-4xxl text-xl md:text-left text-center font-bold mb-9">
          {title}
        </h1>
        {desc ? (
          <div
            className="step-desc md:text-xl1/5 text-lg leading-normal"
            dangerouslySetInnerHTML={{ __html: desc }}
          />
        ) : null}
        <div className="fields mt-12 max-w-md">
          {fields.map((el, i) =>
            el.type === "results" ? (
              <Results key="results" form={this.props.form} />
            ) : (
              <Field
                overlayHandler={this.props.overlayHandler}
                key={el.name}
                index={i}
                change={this.props.changeHandler}
                {...el}
              />
            )
          )}
        </div>
      </div>
    );
  }
}

export default ActiveStep;
